import { memo, useMemo } from "react";

import { TableThWithSortIcon } from "@sso/components/TableThWithSortIcon";
import { BannedIPKeys } from "@sso/constant";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { setBannedIPSortColumn } from "@sso/store/slices/bannedIP";
import { BannedIP } from "@sso/types";
import { LayoutTable, TableWrapper, TD, TH } from "@sso/ui/Table";

import { bannedIPTableColumns } from "./bannedIPTableColumns";

interface BannedIPTableProps {
  bannedIPList: BannedIP[];
}

export const BannedIPTable = memo(({ bannedIPList }: BannedIPTableProps) => {
  const dispatch = useAppDispatch();

  const data: BannedIP[] = useMemo(
    () =>
      bannedIPList.map(item => ({
        ...item,
        [BannedIPKeys.BAN_DATE]: item.banDate ? new Date(item.banDate).toLocaleDateString() : "-",
      })),
    [bannedIPList],
  );

  const handleSortAction = (column: string) => {
    dispatch(setBannedIPSortColumn(column));
  };

  return (
    <TableWrapper>
      <LayoutTable>
        <thead>
          <tr>
            {bannedIPTableColumns.map(col => (
              <TH key={col.field} sortable={col.sortable} onClick={() => col.sortable && handleSortAction(col.field)}>
                {col.sortable ? <TableThWithSortIcon column={col.field} title={col.name} /> : col.name}
              </TH>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.id}>
              {bannedIPTableColumns.map(col => (
                <TD key={col.field}>{item[col.field]}</TD>
              ))}
            </tr>
          ))}
        </tbody>
      </LayoutTable>
    </TableWrapper>
  );
});
